import { CompanyTypeEnum } from 'api';

export const formatCompanyType = (companyType: CompanyTypeEnum) => {
  switch (companyType) {
    case CompanyTypeEnum.MRF:
      return 'Material recovery facility';
    case CompanyTypeEnum.PRF:
      return 'Plastic recovery facility';
    case CompanyTypeEnum.PL_RE:
      return 'Plastic reprocessor';
    case CompanyTypeEnum.MT_RE:
      return 'Metal reprocessor';
    case CompanyTypeEnum.P_MRF:
      return 'Paper MRF';
    case CompanyTypeEnum.PMILL:
      return 'Paper mill';
    case CompanyTypeEnum.PMERC:
      return 'Paper merchant';
    case CompanyTypeEnum.BROKE:
      return 'Broker';
    case CompanyTypeEnum.MT_YD:
      return 'Metal Yard';
    case CompanyTypeEnum.MT_SMELT:
      return 'Metal Smelter';
    default:
      return '';
  }
};
